import { render, staticRenderFns } from "./BodyTypeGrid.vue?vue&type=template&id=7d318b28&"
import script from "./BodyTypeGrid.vue?vue&type=script&lang=js&"
export * from "./BodyTypeGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports